import { useState } from "react";
import { useNavigate } from 'react-router-dom';

const CreateBlog = () => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [author, setAuthor] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();


    const handleSubmit = (e) => {
        e.preventDefault();
        const blog = { title, body, author };
        setIsLoading(true);
        fetch('http://localhost:8000/blogs', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(blog)
        }).then(() => {
            console.log("New Blog added");
            setIsLoading(false);
            // history.go(-1);
            navigate('/');
        })
    }


    return (
        <>
            <form onSubmit={handleSubmit}>
                <label>Title</label>
                <input required type="text" onChange={(e) => setTitle(e.target.value)} />

                <label>Body</label>
                <textarea required onChange={(e) => setBody(e.target.value)} ></textarea>

                <label>Author</label>
                <select required value={author} onChange={(e) => setAuthor(e.target.value)}>
                    <option value="" selected></option>
                    <option value="jomar">jomar</option>
                    <option value="jessa">jessa</option>
                </select>


                {!isLoading && <button >Add Blog</button>}
                {isLoading && <button disabled>Adding blog...</button>}




            </form>
        </>
    );
}

export default CreateBlog;